import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  MapContainer,
  Marker,
  Popup,
  TileLayer,
  useMap,
  useMapEvent,
  ZoomControl
} from "react-leaflet";
import Zoomin from "../../../assets/img/map/search-zoom-in.svg";
import Zoomout from "../../../assets/img/map/search-zoom-out.svg";
import blackMarker from "../../../assets/img/icons/Group 681.svg";
import greenkMarker from "../../../assets/img/icons/Group 680.svg";
import L from "leaflet";
import Button from "../../shared/Button";
import FindLocationButton from "./FindLocationButton";
import useFetch from "../../../hooks/useAxios";
import star from "../../../assets/img/icons/star.svg";
import close from "../../../assets/img/icons/close-square.svg";
import { useNavigate } from "react-router-dom";
function round(value, precision) {
    var multiplier = Math.pow(10, precision || 0);
    return Math.round(value * multiplier) / multiplier;
}

const CityCard = ({info})=>{
  const navigate = useNavigate();

    return(
        <div className="CityCard"  onClick={() => {
          navigate(`/place/${info.code}/${info.slug}`);
        }}>
            <div className="CityCard__img">
                <img src={info.thumbnail.thumbnail_path}/>

            </div>

            <div>
            <div className="d-flex-align justify-start mt-[19px] ">
     

        <div className="text-[#12171C] text-[20px] mb-[-7px] font-[900]">
        {round(info.rating_value,1)}
        </div>
        <img src={star} className="mr-[5px]" />
      </div>
      <div className="my-[10px] text-[#797D82] text-[20px] font-[500]">
      {info.type}
      </div>
      <h4 className="mb-[17px] text-[24px] font-[700] text-[#292D32]" >
        {" "}{info.title}
      </h4>
      <div className="d-flex-space footer-card">
   
   <div className="flex price-box justify-end">
   <div className="pre-cost ml-[4px]">از</div>

     <div className="cost">
       {info.price && info.price}
     </div>
     <div className="pre-cost">تومان</div>

   </div>
       
            
            </div>
        </div>
        </div>
    )
}
const CatMap = ({ markerPos, setMarkerPos ,closeModal}) => {
  const blackIcon = L.icon({
    iconUrl: blackMarker,
    iconSize: [52, 90],
    iconAnchor: [40, 41]
  });
  const greenIcon = L.icon({
    iconUrl: greenkMarker,
    iconSize: [52, 90],
    iconAnchor: [40, 41]
  });
  const [center, setcenter] = useState([35.69439, 51.42151])
  const [boundInfo, setboundInfo] = useState()
  const [cityList, setcityList] = useState([])
  const [cityCardInfo, setCityCardinfo] = useState()

  

  useEffect(() => {}, []);
  const markerRef = useRef();


  function handleMarkerClick(e) {
      //e.latlng.lat
console.log(e.latlng.lat)

   console.log(cityCardInfo)
  }



  const apiCityList = useFetch({
    method: "get",
    url: "api/residences/map",
    noHeader: true,
    trigger: false,
    params:{
        ne_lat:boundInfo?._northEast.lat,
        ne_lng:boundInfo?._northEast.lng,
        sw_lat:boundInfo?._southWest.lat,
        sw_lng:boundInfo?._southWest.lng,
    },
    argFunc: res => {
        setcityList(res.result)
        console.log(res.result)
    
    }
  });
  useEffect(() => {
      if(boundInfo){
        apiCityList.reFetch()

      }
  }, [boundInfo])
  


  const [gebounding,setgetBounding]=useState(true);
  const [map, setMap] = useState(null)
  React.useEffect(() => {
    if (map) {
      const contains = map.getBounds()
      setboundInfo(contains)
      console.log(contains)
    }
  }, [gebounding])
  return (
    <div className="ModalBackground">
      <div className="CatMap">
          <div className="closeIcon" onClick={closeModal}>
              <img src={close} />
          </div>
        
        {markerPos &&
          <MapContainer   ref={setMap} center={center}  zoom={13}>
            <TileLayer
              attribution="&copy; <a href=&quot;http://www.openstreetmap.org/copyright&quot;>OpenStreetMap</a> &copy; <a href=&quot;http://cartodb.com/attributions&quot;>CartoDB</a>"
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
               <FindLocationButton getBounding={gebounding} setgetBounding={setgetBounding} title={"جستجو در این منطقه"}
        markerPosition={[20.27, -157]}
        description="جستجو در این منطقه" />

            {cityList.map(marker =>
              <Marker
                key={marker.id}
                position={[marker.lat, marker.lng]}
                eventHandlers={{
                    click: () => {
                        setCityCardinfo(cityList.filter(city=>city.id === marker.id)[0]);
                    },
                    
                  }}

                ref={markerRef}
                icon={cityCardInfo?.id === marker.id ? greenIcon : blackIcon}
              >
                     {/* <Popup>{marker.name}</Popup> */}
              </Marker>
            )}

            <ZoomControl
              position="bottomright"
              zoomInText={`<img src=${Zoomin} />`}
              zoomOutText={`<img src=${Zoomout} />`}
            />
            {/* <Geocoder address="اصفهان" /> */}
            {/* <MapSearch provider={new OpenStreetMapProvider()} /> */}
          </MapContainer>}
         { cityCardInfo && <CityCard info={cityCardInfo}/>}
      </div>
    </div>
  );
};

export default CatMap;
